var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "afcae5a789ccd549f9c6e2a2f80cdbc1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    fill: "#e21c21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M111.383,179.676L256,0.825l144.617,178.851H307.1v153.3H204.9v-153.3H111.383z M460.399,154.126 v102.2v204.401H51.6V256.326v-102.2l-51.1-51.1v51.1v102.2v255.5h511v-255.5v-102.2v-51.1L460.399,154.126z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.7d811709a8aa25db1f652af4e78a6983.svg";
export { ForwardRef as ReactComponent };